"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const lodash_1 = require("lodash");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const contexts_1 = require("@App/contexts");
const pluralize_1 = __importDefault(require("pluralize"));
const RecordingGroupListHeader = (props) => {
    const { matchHistoryStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const recordingGroupsInfo = matchHistoryStore.recordingGroupsDetails[props.category];
    const recordingGroups = recordingGroupsInfo ? recordingGroupsInfo.content : [];
    return (react_1.default.createElement("div", { className: 'title' },
        react_1.default.createElement("h4", null,
            (0, lodash_1.capitalize)(props.category),
            " Recording ",
            (0, pluralize_1.default)('Group', recordingGroups.length)),
        react_1.default.createElement("div", { className: 'right-link' }, recordingGroups.length > 0 && (react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.rightholder.matchClaim.recordingGroups(rightsholderStore.currentRightsholderId, props.suggestionId, props.category) }, "View More")))));
};
exports.default = (0, mobx_react_1.observer)(RecordingGroupListHeader);
